import { api } from '@/lib/api';
import type {
  IApiResponse,
  ISlackConnection,
  ISlackTestMessageResult,
  ISlackMessageLogPageResponse,
  ISlackUserListResponse,
} from '@skystone/shared';

export const slackApi = {
  getConnectionStatus: async (): Promise<ISlackConnection> => {
    const result = await api.get<IApiResponse<ISlackConnection>>('/slack/connection');
    return result.data;
  },

  verifyConnection: async (): Promise<ISlackConnection> => {
    const result = await api.post<IApiResponse<ISlackConnection>>('/slack/connection/verify');
    return result.data;
  },

  disconnect: async (): Promise<ISlackConnection> => {
    const result = await api.post<IApiResponse<ISlackConnection>>('/slack/connection/disconnect');
    return result.data;
  },

  sendTestMessage: async (email?: string): Promise<ISlackTestMessageResult> => {
    const result = await api.post<IApiResponse<ISlackTestMessageResult>>('/slack/test-message', email ? { email } : undefined);
    return result.data;
  },

  getMessageLog: async (params: { page?: number; pageSize?: number }): Promise<ISlackMessageLogPageResponse> => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set('page', String(params.page));
    if (params.pageSize) searchParams.set('pageSize', String(params.pageSize));
    const query = searchParams.toString();
    const url = query ? `/slack/message-log?${query}` : '/slack/message-log';
    const result = await api.get<IApiResponse<ISlackMessageLogPageResponse>>(url);
    return result.data;
  },

  getUsers: async (params?: { search?: string; includeBots?: boolean; includeInactive?: boolean }): Promise<ISlackUserListResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.set('search', params.search);
    if (params?.includeBots) searchParams.set('includeBots', 'true');
    if (params?.includeInactive) searchParams.set('includeInactive', 'true');
    const query = searchParams.toString();
    const url = query ? `/slack/users?${query}` : '/slack/users';
    const result = await api.get<IApiResponse<ISlackUserListResponse>>(url);
    return result.data;
  },
};
